export default "__VITE_ASSET__Duh8Lgjz__"